
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m",
      function () {
        return require("private-next-pages/m/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m"])
      });
    }
  